const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const AI_CHAT_API_BASE_URL = trimTrailingSlash(
  import.meta.env.VITE_AI_CHAT_API_BASE_URL || ''
);

export default {
  chatStream: '/realtime/sse/v1/realtime/requests',
  taskStatus: '/v2/task/status',
  sessionRecords: '/aisee/v2/agent/session/list',
  sessionDetail: '/aisee/v2/agent/session/detail',
  sessionUpdateName: '/aisee/v2/agent/session/updateName',
  sessionDelete: '/aisee/v2/agent/session/del',
  sessionPin: '/aisee/v2/agent/session/pin',
  sessionShare: '/aisee/v2/agent/session/share', // 分享会话
  customerServicePolicies: '/aisee/v2/agent/policies', // 全局规则 GET GetCustomerServicePolicies
  confirmProposal: '/aisee/v2/training/confirm', // 采纳提案
  queryProposal: '/aisee/v2/training/query-proposal', // 查询一份提案
  queryExperience: '/aisee/v2/training/query-experiences', // 查询经验 GET /v2/training/query-experiences
  cancelStream: '/aisee/agent/v2/sse/agent/cancel', // 取消流
};

export const resolveAiChatUrl = (path: string) =>
  `${AI_CHAT_API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
